import {HtmlInterfaceName} from "./html-interface-names";
import {HtmlTagName} from "./html-tag-names";

/**
 * A Map between HTML interfaces and the tags that inherits from it
 * @type {Map<HtmlInterfaceName, HtmlTagName[]>}
 */
export const HTML_INTERFACE_NAME_TO_TAG_NAMES_MAP = new Map<HtmlInterfaceName, HtmlTagName[]>([
	["HTMLAnchorElement", ["a"]],
	["HTMLAreaElement", ["area"]],
	["HTMLAudioElement", ["audio"]],
	["HTMLBaseElement", ["base"]],
	["HTMLQuoteElement", ["blockquote", "q"]],
	["HTMLBodyElement", ["body"]],
	["HTMLBRElement", ["br"]],
	["HTMLButtonElement", ["button"]],
	["HTMLCanvasElement", ["canvas"]],
	["HTMLTableCaptionElement", ["caption"]],
	["HTMLTableColElement", ["col"]],
	["HTMLDataElement", ["data"]],
	["HTMLDataListElement", ["datalist"]],
	["HTMLDirectoryElement", ["dir"]],
	["HTMLDivElement", ["div"]],
	["HTMLDListElement", ["dl"]],
	["HTMLEmbedElement", ["embed"]],
	["HTMLFieldSetElement", ["fieldset"]],
	["HTMLFontElement", ["font"]],
	["HTMLFormElement", ["form"]],
	["HTMLFrameElement", ["frame"]],
	["HTMLFrameSetElement", ["frameset"]],
	["HTMLHeadingElement", ["h1", "h2", "h3", "h4", "h5", "h6"]],
	["HTMLHeadElement", ["head"]],
	["HTMLHRElement", ["hr"]],
	["HTMLHtmlElement", ["html"]],
	["HTMLIFrameElement", ["iframe"]],
	["HTMLImageElement", ["img"]],
	["HTMLInputElement", ["input"]],
	["HTMLModElement", ["del", "ins"]],
	["HTMLLabelElement", ["label"]],
	["HTMLLegendElement", ["legend"]],
	["HTMLLIElement", ["li"]],
	["HTMLLinkElement", ["link"]],
	["HTMLPreElement", ["pre"]],
	["HTMLMapElement", ["map"]],
	["HTMLMarqueeElement", ["marquee"]],
	["HTMLMenuElement", ["menu"]],
	["HTMLMetaElement", ["meta"]],
	["HTMLMeterElement", ["meter"]],
	["HTMLUnknownElement", []],
	["HTMLObjectElement", ["object"]],
	["HTMLOListElement", ["ol"]],
	["HTMLOptGroupElement", ["optgroup"]],
	["HTMLOptionElement", ["option"]],
	["HTMLOutputElement", ["output"]],
	["HTMLParagraphElement", ["p"]],
	["HTMLParamElement", ["param"]],
	["HTMLPictureElement", ["picture"]],
	["HTMLProgressElement", ["progress"]],
	["HTMLScriptElement", ["script"]],
	["HTMLSelectElement", ["select"]],
	["HTMLSourceElement", ["source"]],
	["HTMLSpanElement", ["span"]],
	["HTMLStyleElement", ["style"]],
	["HTMLTableElement", ["table"]],
	["HTMLTableSectionElement", ["tbody", "thead", "tfoot"]],
	["HTMLTableDataCellElement", ["td"]],
	["HTMLTemplateElement", ["template"]],
	["HTMLTextAreaElement", ["textarea"]],
	["HTMLTableHeaderCellElement", ["th"]],
	["HTMLTimeElement", ["time"]],
	["HTMLTitleElement", ["title"]],
	["HTMLTableRowElement", ["tr"]],
	["HTMLTrackElement", ["track"]],
	["HTMLUListElement", ["ul"]],
	["HTMLVideoElement", ["video"]]
]);